module.exports = __webpack_public_path__ + "img/EDIT.7b81fd9b.svg";